export default __webpack_public_path__ + "static/media/animated-mockup.429c0766.gif";